<template>
    <v-row justify="center">
      <v-dialog :value="confirmCommentOpen" persistent max-width="540">
        <v-card>
          <v-card-title class="headline">{{ title }}</v-card-title>
          <v-text-field v-model="promise"  type="number" outlined dense label="Promise" class="pa-5">
          </v-text-field>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="orange" @click="onClose">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green" @click="onConfirm" :disabled="!promise"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </template>
  
  <script>
  export default {
    props: ["title", "confirmCommentOpen", "color"],
    name: "ConfirmModal",
    data() {
      return {
        promise: "",
      };
    },
    methods: {
      onClose() {
        this.promise = null;
        this.$emit("cancelPromiseConfirm");
      },
      onConfirm() {
        this.$emit("confirmPromise", this.promise);
      },
    },
  };
  </script>
  